import { NgModule } from '@angular/core';
import { AnchorScrollService } from './anchor-scroll.service';

@NgModule({
    providers: [AnchorScrollService]
})
export class AnchorScrollModule {
    constructor(anchorScrollService: AnchorScrollService) {
        anchorScrollService.appInitialize();
    }
}
